export interface Volume {
  label: string
  title: string
  paragraphs: string[]
}

export const volumes: Volume[] = [
  {
    label: 'VOLUME I',
    title: 'The 7-Step Dental Diagnostic Framework',
    paragraphs: [
      'Discover the complete 7-step framework for evaluating a dental case, from the initial patient assessment to a structured clinical diagnosis.',
      'Learn what to evaluate, what questions to ask, what information to collect and how to organize your findings before making important treatment decisions.',
    ],
  },
  {
    label: 'VOLUME II',
    title: 'How to Turn Clinical Findings Into a Structured Diagnosis',
    paragraphs: [
      'Learn how to organize the information you collect from the patient’s history, clinical examination, photographs, radiographs and other diagnostic records.',
      'Discover how to distinguish primary findings, secondary findings and contributing factors so you can build a more complete picture of the case.',
    ],
  },
  {
    label: 'VOLUME III',
    title: 'The Clinical Risk & Red Flag Detection System',
    paragraphs: [
      'Learn how to identify findings that may change the diagnosis, increase case complexity or require additional evaluation before treatment.',
      'Practical protocols and checklists to help you recognize what deserves closer attention and what should never be overlooked.',
    ],
  },
  {
    label: 'VOLUME IV',
    title: 'The Master Map for Complex Dental Cases',
    paragraphs: [
      'Learn how to approach cases that involve multiple clinical problems and create greater diagnostic uncertainty.',
      'Use structured protocols and decision trees to organize competing findings, establish priorities and create a clearer clinical pathway.',
    ],
  },
  {
    label: 'VOLUME V',
    title: 'From Diagnosis to Treatment Strategy',
    paragraphs: [
      'Learn how to connect your diagnostic findings to a coherent treatment strategy.',
      'Build the clinical reasoning pathway: Finding → Diagnosis → Clinical Objective → Options → Decision, instead of jumping from a problem straight to a treatment.',
    ],
  },
  {
    label: 'VOLUME VI',
    title: 'The Final Clinical Validation Protocol',
    paragraphs: [
      'Before presenting or starting a treatment, you need to know whether you’ve evaluated everything that matters.',
      'Use a final validation protocol to review your diagnosis, verify your conclusions, identify potential omissions and decide with greater clinical clarity.',
    ],
  },
]

export interface Bonus {
  label: string
  title: string
  paragraphs: string[]
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    label: 'BONUS #1',
    title: 'The Complete Dental Diagnostic Checklist',
    paragraphs: [
      'A practical checklist with the essential points to review before finalizing your diagnosis.',
      'Use it chairside to make sure you haven’t overlooked important clinical information before moving forward with treatment.',
    ],
    value: '$37 USD',
    image: 'https://cdn.magicpatterns.com/uploads/n47MYRSW8Ucuo45EMRCZwE/BONUS_1_DIAGNOSTICO-EN.png',
  },
  {
    label: 'BONUS #2',
    title: 'Clinical Case Analysis Worksheet',
    paragraphs: [
      'A ready-to-use worksheet designed to help you organize patient information, clinical findings, diagnostic records and treatment priorities in one place.',
      'Stop having scattered information across different notes and start seeing the complete clinical picture.',
    ],
    value: '$27 USD',
    image: 'https://cdn.magicpatterns.com/uploads/hmDL8Dm6F2FaqTWoZyYYng/BONUS_2_DIAGNOSTICO-EN.png',
  },
  {
    label: 'BONUS #3',
    title: 'Dental Photography Documentation Protocol',
    paragraphs: [
      'Learn exactly which clinical photographs to capture, how to organize them and what each image should help you evaluate.',
      'Build a more consistent photographic record that makes case analysis easier and more structured.',
    ],
    value: '$29 USD',
    image: 'https://cdn.magicpatterns.com/uploads/4YKZXv2Aegva7Fpa1Q8zQn/BONUS_3_DIAGNOSTICO-EN.png',
  },
  {
    label: 'BONUS #4',
    title: 'Clinical Patient Evaluation Dashboard',
    paragraphs: [
      'A professional digital template to organize your patient’s diagnostic information, track key findings and keep important clinical considerations visible throughout the case.',
    ],
    value: '$24 USD',
    image: 'https://cdn.magicpatterns.com/uploads/aA6t55Cqat5NoRF6rqEost/BONUS_4_DIAGNOSTICO-EN.png',
  },
  {
    label: 'BONUS #5',
    title: 'Clinical Communication Scripts for Dentists',
    paragraphs: [
      'Ready-to-use scripts to help you explain diagnoses, clinical findings, treatment recommendations and next steps to your patients in a simple and professional way.',
      'Because making the right clinical decision is only part of the job. You also need to communicate it clearly.',
    ],
    value: '$37 USD',
    image: 'https://cdn.magicpatterns.com/uploads/2iDJtDENE4dY9BbkCjNifB/BONUS_5_DIAGNOSTICO-EN.png',
  },
]
